export default __webpack_public_path__ + "static/media/mittellanger_bus_vordersitze.5bfb56ec.jpg";